import { render, staticRenderFns } from "./MainAppBar.vue?vue&type=template&id=45fffbbc"
import script from "./MainAppBar.vue?vue&type=script&lang=js"
export * from "./MainAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports